import { render, staticRenderFns } from "./information.vue?vue&type=template&id=8b3c40c0&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=8b3c40c0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./information.vue?vue&type=style&index=1&id=8b3c40c0&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3c40c0",
  null
  
)

export default component.exports